const generateRandomColor = () => {
	const letters = '0123456789ABCDEF';
	let color = '#';

	const randomValues = new Uint8Array(6);
	crypto.getRandomValues(randomValues);

	for (let i = 0; i < 6; i++) {
		color += letters[randomValues[i] % 16];
	}

	return color;
};

export default generateRandomColor;
